<template>
    <div class="Orders"
        :class="'Orders--showCurrent-'+showCurrent">

        <error v-if="asyncFormError" :message="errorMessage"></error>
        <button class="Button" @click="getOrganiserReport">Organiser report</button>
        <div class="Report-search">
          <input-field
            :definition="{
              label: 'Start Date',
              id: 'startDate',
            }"
            label="Start Date"
            v-model="dateStart"
            v-on:change="dateStart = $event"
            ></input-field>
          <input-field
            :definition="{
              label: 'End Date',
              id: 'endDate',
            }"
            label="End Date"
            v-model="dateEnd"
            v-on:change="dateStart = $event"
            ></input-field>
          <button class="Button" @click="init">Search</button>
        </div>

        <div class="Orders-fulfilled" v-if="!showCurrent && !asyncFormError">
            <p>{{overview.date | moment("ddd, MMM Do YYYY")}} - {{overview.dateEnd | moment("ddd, MMM Do YYYY")}}</p>
            <p>Total events: {{events.length}}</p>
            <p>Total takings: &pound;{{overview.totalTaken | currency}}</p>
            <p>Total profit: {{overview.totalProfitAdjust | currency}}</p>
        </div>

        <!--
            --
            -- Table for weekly totals and transfers --
            --
        -->
        <div class="Report" v-if="false">
            <ul class="Report-header">
                <li class="Report-cell Report-cell--id">ID</li>
                <li class="Report-cell Report-cell--name">Name</li>
                <li class="Report-cell Report-cell--date">Date</li>
                <li class="Report-cell">Price</li>
                <li class="Report-cell">Sold</li>
                <li class="Report-cell">Taken</li>
                <li class="Report-cell">Paid out</li>
                <li class="Report-cell">Stripe Fees</li>
<!--                <li class="Report-cell">Profit pre-cancellations</li>-->
                <li class="Report-cell">Profit</li>
            </ul>
            <div
                v-for="event in events"
                :key="event.id"
                class="Report-wrapper"
            >
                <div class="Report-body"
                    v-if="event.statusType !== 'CANCELLED'">
                    <div class="Report-cell Report-cell--id">{{event.id}}</div>
                    <div class="Report-cell Report-cell--name">{{event.name}}</div>
                    <div class="Report-cell Report-cell--date">{{event.date | moment("ddd Do MMM YYYY, HH:mm")}}</div>
                    <div class="Report-cell">{{event.price | currency}}</div>
                    <div class="Report-cell">{{event.sold}}</div>
                    <div class="Report-cell">{{event.total_price * event.sold | currency}}</div>
                    <div class="Report-cell">{{event.owed | currency}}</div>
                    <div class="Report-cell">{{event.fees | currency}}</div>
<!--                    <div class="Report-cell">{{event.profit | currency}}</div>-->
<!--                    <div class="Report-cell">{{event.preAdjustedTotal | currency}}</div>-->
                    <div class="Report-cell">{{event.adjustedTotal | currency}}</div>
                </div>
                <div
                    v-for="ticket in event.tickets"
                    :key="ticket.id">
                    <div v-if="ticket.type === 'Cancelled'">
                        <div
                            v-for="refund in ticket.refunds"
                            :key="refund.id"
                            class="Report-body"
                        >
                            <div class="Report-cell">Cancelled ticket quantity: {{ticket.quantity}}</div>
                            <div class="Report-cell">Amount: {{refund.amount | currency}}</div>
                            <div class="Report-cell">Refunded: {{refund.amount_refunded | currency}}</div>
                            <div class="Report-cell">Fee: {{refund.fee | currency}}</div>
                            <div class="Report-cell">Remaining: {{refund.amount - refund.amount_refunded - refund.fee | currency}}</div>
                            <div class="Report-cell">Ticket code: {{refund.code}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-for="event in cancelledEvents"
                :key="event.id"
                class="Report-wrapper"
            >
                <div class="Report-body">
                    <div class="Report-cell Report-cell--id">CANCELLED {{event.id}}</div>
                    <div class="Report-cell Report-cell--name">{{event.name}}</div>
                    <div class="Report-cell Report-cell--date">{{event.date | moment("ddd Do MMM YYYY, HH:mm")}}</div>
                    <div class="Report-cell">{{event.price | currency}}</div>
                    <div class="Report-cell">{{event.sold}}</div>
                    <div class="Report-cell">{{event.total_price * event.sold | currency}}</div>
                    <div class="Report-cell">{{event.owed | currency}}</div>
                    <div class="Report-cell">{{event.fees | currency}}</div>
<!--                    <div class="Report-cell">{{event.profit | currency}}</div>-->
                    <div class="Report-cell">{{event.adjustedTotal | currency}}</div>
<!--                    <div class="Report-cell">{{event.preAdjustedTotal | currency}}</div>-->
                </div>
                <div
                    v-for="ticket in event.tickets"
                    :key="ticket.id">
                    <div>
                        <div
                            v-for="refund in ticket.refunds"
                            :key="refund.id"
                            class="Report-body"
                        >
                            <div class="Report-cell">Cancelled ticket quantity: {{ticket.quantity}}</div>
                            <div class="Report-cell">Amount: {{refund.amount | currency}}</div>
                            <div class="Report-cell">Refunded: {{refund.amount_refunded | currency}}</div>
                            <div class="Report-cell">Fee: {{refund.fee | currency}}</div>
                            <div class="Report-cell">Remaining: {{refund.amount - refund.amount_refunded - refund.fee | currency}}</div>
                            <div class="Report-cell">Ticket code: {{refund.code}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Report-body">
                <div class="Report-cell Report-cell--totals">Totals</div>
                <div class="Report-cell">Tickets sold: {{overview.totalSold | bigNumber}}</div>
                <div class="Report-cell">Funds taken: {{overview.totalTaken | currency}}</div>
                <div class="Report-cell">Funds paid out: {{overview.totalOwed | currency}}</div>
                <div class="Report-cell">Profit before cancellations: {{overview.totalProfit | currency}}</div>
                <div class="Report-cell">Profit after cancellations: {{overview.totalProfitAdjust | currency}}</div>
            </div>
        </div>

        <table class="Report">
            <thead class="Report-header">
                <th class="Report-cell Report-cell--id">ID</th>
                <th class="Report-cell Report-cell--name">Name</th>
                <th class="Report-cell Report-cell--date">Date</th>
                <th class="Report-cell">Price</th>
                <th class="Report-cell">Sold</th>
                <th class="Report-cell">Taken</th>
                <th class="Report-cell">Paid out</th>
                <th class="Report-cell">Stripe Fees</th>
<!--                <th class="Report-cell">Profit pre-cancellations</th>-->
                <th class="Report-cell">Profit</th>
            </thead>
            <tr
                v-for="event in notCancelledEvents"
                :key="event.id"
                class="Report-body"
            >
                <td class="Report-cell Report-cell--id">{{event.id}}</td>
                <td class="Report-cell Report-cell--name">{{event.name}}</td>
                <td class="Report-cell Report-cell--date">{{event.date | moment("ddd Do MMM YYYY, HH:mm")}}</td>
                <td class="Report-cell">{{event.price | currency}}</td>
                <td class="Report-cell">{{event.sold}}</td>
                <td class="Report-cell">{{event.total_price * event.sold | currency}}</td>
                <td class="Report-cell">{{event.owed | currency}}</td>
                <td class="Report-cell">{{event.fees | currency}}</td>
<!--                   <td class="Report-cell">{{event.profit | currency}}</td>-->
<!--                   <td class="Report-cell">{{event.preAdjustedTotal | currency}}</td>-->
                <td class="Report-cell">{{event.adjustedTotal | currency}}</td>
<!--                <div-->
<!--                    v-for="ticket in event.tickets">-->
<!--                    <div v-if="ticket.type === 'Cancelled'">-->
<!--                        <div-->
<!--                            v-for="refund in ticket.refunds"-->
<!--                            class="Report-body"-->
<!--                        >-->
<!--                            <div class="Report-cell">Cancelled ticket quantity: {{ticket.quantity}}</div>-->
<!--                            <div class="Report-cell">Amount: {{refund.amount | currency}}</div>-->
<!--                            <div class="Report-cell">Refunded: {{refund.amount_refunded | currency}}</div>-->
<!--                            <div class="Report-cell">Fee: {{refund.fee | currency}}</div>-->
<!--                            <div class="Report-cell">Remaining: {{refund.amount - refund.amount_refunded - refund.fee | currency}}</div>-->
<!--                            <div class="Report-cell">Ticket code: {{refund.code}}</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </tr>
            <tr
                v-for="event in cancelledEvents"
                :key="event.id"
                class="Report-body"
            >
                    <td class="Report-cell Report-cell--id">CANCELLED {{event.id}}</td>
                    <td class="Report-cell Report-cell--name">{{event.name}}</td>
                    <td class="Report-cell Report-cell--date">{{event.date | moment("ddd Do MMM YYYY, HH:mm")}}</td>
                    <td class="Report-cell">{{event.price | currency}}</td>
                    <td class="Report-cell">{{event.sold}}</td>
                    <td class="Report-cell">{{event.total_price * event.sold | currency}}</td>
                    <td class="Report-cell">{{event.owed | currency}}</td>
                    <td class="Report-cell">{{event.fees | currency}}</td>
<!--                    <td class="Report-cell">{{event.profit | currency}}</td>-->
                    <td class="Report-cell">{{event.adjustedTotal | currency}}</td>
<!--                    <td class="Report-cell">{{event.preAdjustedTotal | currency}}</td>-->
<!--                <div
                    v-for="ticket in event.tickets">
                    <div>
                        <div
                            v-for="refund in ticket.refunds"
                            class="Report-body"
                        >
                            <div class="Report-cell">Cancelled ticket quantity: {{ticket.quantity}}</div>
                            <div class="Report-cell">Amount: {{refund.amount | currency}}</div>
                            <div class="Report-cell">Refunded: {{refund.amount_refunded | currency}}</div>
                            <div class="Report-cell">Fee: {{refund.fee | currency}}</div>
                            <div class="Report-cell">Remaining: {{refund.amount - refund.amount_refunded - refund.fee | currency}}</div>
                            <div class="Report-cell">Ticket code: {{refund.code}}</div>
                        </div>
                    </div>
                </div>-->
            </tr>
            <tr class="Report-body">
                <td class="Report-cell Report-cell--totals">Totals</td>
                <td class="Report-cell">Tickets sold: {{overview.totalSold | bigNumber}}</td>
                <td class="Report-cell">Funds taken: {{overview.totalTaken | currency}}</td>
                <td class="Report-cell">Funds paid out: {{overview.totalOwed | currency}}</td>
                <td class="Report-cell">Profit before cancellations: {{overview.totalProfit | currency}}</td>
                <td class="Report-cell">Profit after cancellations: {{overview.totalProfitAdjust | currency}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import cookieModel from "../models/cookie";
import moment from "moment";

export default {
    mounted() {
        // window.setInterval(() => {
        //     this.init();
        // }, 30000);
        // this.init();
    },
    watch: {},
    computed: {
      notCancelledEvents() {
        return this.events.filter(event => event.statusType !== 'CANCELLED');
      },
    },
    methods: {
        init: function() {
            let vm = this;
            let url = this.baseUrl + "/einstein/monthly-stats";
            let postData = {
                venue: vm.venueId,
                start: vm.dateStart,
                end: vm.dateEnd,
            };

            vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' +
              cookieModel.getCookie('ticketlab_access');

            // Get events for this company
            vm.axiosInstance
                .post(url, postData)
                .then(function(response) {
                    if (response.data) {
                        // reset error
                        vm.asyncFormError = false;
                        if (response.data.status === 'error') {
                            vm.asyncFormError = true;
                            vm.errorMessage = response.data.message;
                        } else {
                            vm.events = response.data.events;
                            vm.cancelledEvents = response.data.cancelledEvents;

                            vm.overview = {
                                date: response.data.start,
                                dateEnd: response.data.end,
                                totalSold: response.data.totalSold,
                                totalTaken: response.data.totalTaken,
                                totalOwed: response.data.totalOwed,
                                totalProfit: response.data.totalProfit,
                                totalProfitAdjust: 0,
                            };

                            vm.events.forEach(function(event) {
                                event.adjustedTotal = Number(event.profit);
                                event.preAdjustedTotal = Number(event.profit);

                                event.tickets.forEach(function(ticket) {
                                    if (ticket.type === 'Cancelled') {
                                        ticket.refunds.forEach(function(refund) {
                                            event.adjustedTotal += Number(refund.amount) - Number(refund.amount_refunded) - Number(refund.fee);
                                        });
                                    }
                                });
                                vm.overview.totalProfitAdjust += Number(event.adjustedTotal);
                            });

                            vm.cancelledEvents.forEach(function(event) {
                                event.adjustedTotal = Number(event.profit);
                                event.preAdjustedTotal = Number(event.profit);
                                event.fees = 0;

                                event.tickets.forEach(function(ticket) {
                                    ticket.refunds.forEach(function(refund) {
                                        if (refund.fee === undefined) {
                                          console.log('fee is undefined:', refund);
                                        } else {
                                          event.fees += Number(refund.fee);
                                          event.adjustedTotal += Number(refund.amount) - Number(refund.amount_refunded) - Number(refund.fee);
                                        }
                                    });
                                });
                                console.log(event.adjustedTotal);
                                vm.overview.totalProfitAdjust += Number(event.adjustedTotal);
                            });
                        }
                    } else {
                        console.log("nada", response);
                    }
                })
                .catch(function(error) {
                    console.log(error.response);
                    if (error.response.data && error.response.data.reason) {
                        vm.asyncFormError = error.response.data.reason;
                    }
                });
        },
        getOrganiserReport: function () {
          const vm = this;

          vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' +
            cookieModel.getCookie('ticketlab_access');

          vm.axiosInstance.post(`${vm.baseUrl}/einstein/reports/organisers`).then(response => {
            console.log(response.data);
          }).catch(error => {
            console.log(error);
          });
        }
    },

    data: function() {
        return {
            baseUrl: process.env.VUE_APP_API_URL,
            venueId: process.env.VUE_APP_VENUE_ID,
            axiosInstance: axios.create({
                baseURL: this.baseUrl
            }),
            events: [],
            cancelledEvents: [],
            totalPrices: 0,
            totalStripeFees: 0,
            totalTicketlabFees: 0,
            totalToTransfer: 0,
            showCurrent: false,
            overview:{},
            asyncFormError: false,
            dateStart: moment(new Date).subtract(1, 'months').startOf('month').format('DD MMM YYYY'),
            dateEnd: moment(new Date).subtract(1, 'months').endOf('month').format('DD MMM YYYY')
        };
    },
};
</script>

<style lang="scss" scoped>
.Report {
  &-search {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 1rem;

    .Form-inputGroup,
    .Button {
      width: 30%;
      margin-right: 3%;
      max-width: 300px;
    }
  }

  &-header {
    position: sticky;
    top: 0;
    background: white;
  }
}
</style>
